<template>
  <div>
    <div v-if="clientData" class="px-2">
      <client-detail-container :client-data="clientData" />
    </div>
    <choose-client v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ChooseClient from '../../components/client-detail/ChooseClient.vue'
import ClientDetailContainer from '../../components/client-detail/ClientDetailContainer.vue'

export default {
  components: { ChooseClient, ClientDetailContainer },
  computed: {
    /**
       * Mapping selected client from the Vuex store to local version
       */
    ...mapState('client', ['clientData'])
  }
}
</script>
